(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["website-contact-form"] && !Shopify.designMode) return;
  try {
    (function () {
    var START = Date.now();

    document.querySelectorAll('form[data-wcf]').forEach(function (form) {
      if (form.dataset.wcfBound) return;
      form.dataset.wcfBound = '1';

      var status = form.querySelector('[data-wcf-status]');
      var btn = form.querySelector('.wcf__submit');
      var elapsedField = form.querySelector('[data-wcf-elapsed]');
      var okMsg = form.getAttribute('data-wcf-success') || 'Thanks — we’ll be in touch.';
      var errMsg = 'Something went wrong. Please email us directly.';

      function show(msg, isError) {
        status.hidden = false;
        status.textContent = msg;
        status.classList.toggle('wcf__status--error', !!isError);
      }

      // Sentence layout: the subject words act as a radio group feeding the hidden subject field,
      // and the message box grows with what is typed.
      var subjectField = form.querySelector('[data-wcf-subject]');
      var words = form.querySelectorAll('[data-wcf-word]');
      function pickWord(chosen) {
        words.forEach(function (w) {
          w.setAttribute('aria-checked', w === chosen ? 'true' : 'false');
        });
        if (subjectField) subjectField.value = chosen ? chosen.getAttribute('data-wcf-word').trim() : '';
      }
      words.forEach(function (w) {
        w.addEventListener('click', function () {
          pickWord(w);
        });
      });
      var ta = form.querySelector('.wcf__ta');
      if (ta) {
        ta.addEventListener('input', function () {
          ta.style.height = 'auto';
          ta.style.height = ta.scrollHeight + 'px';
        });
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var hp = form.querySelector('[name="_gotcha"]');
        if (hp && hp.value) return; // bot

        var email = form.querySelector('[name="email"]');
        var message = form.querySelector('[name="message"]');
        if (!email.value.trim() || !message.value.trim()) {
          show('Please add your email and a message.', true);
          return;
        }

        var subject = form.querySelector('[name="subject"]');
        if (subject && subject.required && !subject.value.trim()) {
          show(form.hasAttribute('data-wcf-sentence') ? 'Please pick what it’s about.' : 'Please add a subject.', true);
          return;
        }

        if (elapsedField) elapsedField.value = String(Date.now() - START);

        btn.disabled = true;
        show('Sending…', false);

        fetch(form.action, {
          method: 'POST',
          mode: 'no-cors',
          body: new URLSearchParams(new FormData(form))
        })
          .then(function () {
            show(okMsg, false);
            form.reset();
          })
          .catch(function () {
            show(errMsg, true);
          })
          .finally(function () {
            btn.disabled = false;
          });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
